import { ref } from 'vue'

import { defineStore } from 'pinia'

/**
 * Shared UI state for the events directory search input.
 *
 * The input lives in the Client Portal top bar while the directory grid that
 * consumes the query lives on the upcoming/past pages.
 *
 * NO server data, NO service imports, NO API calls.
 */
export const useEventsDirectorySearchStore = defineStore('events-directory-search-ui', () => {
  const searchQuery = ref('')

  const setSearchQuery = (value: string) => {
    searchQuery.value = value
  }

  const reset = () => {
    searchQuery.value = ''
  }

  return {
    searchQuery,
    setSearchQuery,
    reset,
  }
})
